module.exports = {"tag":"3.25","short":"0444ad5","version":"v3.25","force":false}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 1039
// module chunks = 0